import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    height: 150px;
    width: 500px;
    position: relative;
    display: block;
    margin-left: auto;
    margin-right: auto;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
    > * {
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }
}
`;

export const Wave = styled.div`
    margin-left: 50px;
    height: 100%;
    width: 440px;
}
`;
